export enum ClientType {
  App = 'app',
  Web = 'web',
}